import React from 'react';
import { View, Text } from '@ui/atoms';
import isEqual from 'react-fast-compare';
import PropTypes from 'prop-types';
import FormError from '@ui/atoms/FormError';

function FormControl({
  label,
  required = false,
  variant = 'default',
  error = undefined,
  labelProps = undefined,
  children,
  ...props
}) {
  const displayLabel = required ? `${label} *` : label;

  return (
    <View {...props}>
      <Text
        variants={['label', variant === 'light' && 'labelLight'].filter(Boolean)}
        {...labelProps}
        sx={{ ...labelProps?.sx, mb: '$1' }}
      >
        {displayLabel}
      </Text>
      {React.Children.map(children, (child) => {
        if (child && child.type) {
          const ComponentType = child.type.WrappedComponent || child.type.render || child.type;
          const typeName = ComponentType.displayName || ComponentType.name || 'non défini';
          // On récupère la prop explicite ou la propriété statique
          const hasCloneProp = child.props.cloneError;
          const staticClone = ComponentType.shouldCloneError;
          const shouldClone =
            (hasCloneProp !== undefined ? hasCloneProp : staticClone) ||
            ['Input', 'Select', 'FilePicker'].includes(typeName);
          if (shouldClone) {
            const newError = child.props.error || !!error;
            return React.cloneElement(child, { error: newError });
          }
        }
        return child;
      })}
      {error && typeof error !== 'boolean' && (
        <View sx={{ mt: '$2' }}>
          <FormError error={error} />
        </View>
      )}
    </View>
  );
}

FormControl.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  required: PropTypes.bool,
  variant: PropTypes.oneOf(['light', 'default']),
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ key: PropTypes.string, values: PropTypes.object })]),
  labelProps: PropTypes.shape({}),
};

export default React.memo(FormControl, isEqual);
